import { createFileRoute } from '@tanstack/react-router';

import { requireGuest } from '@/app/lib/auth-guard';
import { VerifyEmailPage } from '@/auth/pages/verify-email';

export const Route = createFileRoute('/users/verify-email/$token')({
  beforeLoad: () => {
    requireGuest();
  },
  component: VerifyEmailRoute
});

function VerifyEmailRoute() {
  const { token } = Route.useParams();

  return <VerifyEmailPage token={token}/>;
}
